import { SourceMarket } from '@revolugo/booking-api-client'
import { dayjs } from '@revolugo/common/utils'

import type { HotelOffersRequest } from './hotel-offers-request.ts'
import type { HotelOfferRequestCreateApi } from '@revolugo/booking-api-client'

export const getDefaultHotelOfferRequest: () => HotelOfferRequestCreateApi =
  () => ({
    adultCount: 1,
    checkInDate: formatQueryDate(new Date()),
    checkOutDate: formatQueryDate(dayjs().add(1, 'day').toDate()),
    roomCount: 1,
    sourceMarket: SourceMarket.Fr,
  })

export const buildElementsHotelOffersRequest = (
  payload: HotelOffersRequest,
): Omit<HotelOfferRequestCreateApi, 'eventMetadata'> => {
  const defaultHotelOfferRequest = getDefaultHotelOfferRequest()

  return {
    ...defaultHotelOfferRequest,
    ...payload,
    adultCount:
      toNumber(payload.adultCount) || defaultHotelOfferRequest.adultCount,
    roomCount:
      toNumber(payload.roomCount) || defaultHotelOfferRequest.roomCount,
  }
}
